import { Attributes } from "../model/attributes";

export class Update {
    constructor(
        public admin: boolean,
        public email: string,
        public attributes: Attributes
    ) { }
}
